import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const buttonIconIconFn = /* @__PURE__ */ createRecipe('button-icon-icon', {
  "size": "m"
}, [])

const buttonIconIconVariantMap = {
  "size": [
    "xs",
    "xl",
    "s",
    "m",
    "l"
  ]
}

const buttonIconIconVariantKeys = Object.keys(buttonIconIconVariantMap)

export const buttonIconIcon = /* @__PURE__ */ Object.assign(memo(buttonIconIconFn.recipeFn), {
  __recipe__: true,
  __name__: 'buttonIconIcon',
  __getCompoundVariantCss__: buttonIconIconFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: buttonIconIconVariantKeys,
  variantMap: buttonIconIconVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, buttonIconIconVariantKeys)
  },
  getVariantProps: buttonIconIconFn.getVariantProps,
})